// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"27ddfe6c","641":"093cac2a","743":"ed8c31a8","821":"4ef5e40a"}[chunkId] + ".chunk.js");